import { call, put, takeEvery } from 'redux-saga/effects';
import { fetchEntity } from '@classpass/saga-tools';
import { connectCredentials } from 'store/saga/entities/bound';
import { sagaMessages } from './Connect.messages';
import { createSuccessSnackbar } from '../../components/Snackbar';

export const CONNECT_INTEGRATOR = 'CONNECT_INTEGRATOR';

export const connectIntegrator = ({ integrator, partnerId, apiKey }, { rejectSubmit }) => ({
  type: CONNECT_INTEGRATOR,
  integrator,
  partnerId,
  apiKey,
  rejectSubmit,
});

export function* doConnect(client, action) {
  const { partnerId, apiKey, rejectSubmit } = action;
  try {
    yield call(fetchEntity, connectCredentials, [client, { partnerId, apiKey }]);
    yield put(createSuccessSnackbar(sagaMessages.success));
  } catch (error) {
    yield call(rejectSubmit, sagaMessages.invalidCredentials);
  }
}

export function* watchConnectActions(client) {
  yield takeEvery(CONNECT_INTEGRATOR, doConnect, client);
}
